import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

interface IDialogTitleContent {
	title: string;
	content: string;
	dialogWidth?: string;
	useWideConfirmButton?: boolean;
	useCompactContent?: boolean;
}
@Component({
	selector: 'copo-dialog-ok-cancel',
	templateUrl: './dialog-ok-cancel.component.html',
	styleUrl: './dialog-ok-cancel.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatDialogModule,
		TranslateModule,

		MatButtonModule,
	],
})
export class DialogOkCancelComponent implements OnInit {
	constructor(

		@Inject(MAT_DIALOG_DATA) public data: IDialogTitleContent,

		private readonly dialogRef: MatDialogRef<DialogOkCancelComponent>
	) {}

	ngOnInit() {
		this.dialogRef.updateSize(this.data.dialogWidth ?? '60%');
		this.dialogRef.disableClose = true;
	}
}
